import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { MaxHeightProps, MaxWidthProps, SizeProps } from 'styled-system';
import { maxHeight, maxWidth } from 'styled-system';

import type { ThemedComponent } from '../../theme/theme';
import type { IconName } from '../Icon';
import Icon from '../Icon';

interface CopyIconProps {
  color?: string;
  name?: IconName;
}

type CopyIconStyledProps = SizeProps & MaxWidthProps & MaxHeightProps;

const COPY_ICON_SIZE = '26px';

const UnstyledCopyIcon: ThemedComponent<CopyIconProps, CopyIconStyledProps> = styled(Icon)<any>`
  ${maxWidth};
  ${maxHeight};

  fill: ${({ color: iconColor }) => iconColor};
`;

const CopyIcon = (props: ComponentProps<typeof UnstyledCopyIcon>) => (
  <UnstyledCopyIcon
    size={COPY_ICON_SIZE}
    maxWidth={COPY_ICON_SIZE}
    maxHeight={COPY_ICON_SIZE}
    name="copy"
    {...props}
  />
);

export default CopyIcon;
